import React from 'react';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { MoreTestimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { MethodOverview } from './components/MethodOverview';
import { MaterialPreview } from './components/MaterialPreview';
import { FAQ } from './components/FAQ';
import { CostComparison } from './components/CostComparison';
import { Guarantee, Footer } from './components/Footer';
import { FloatingNotification } from './components/FloatingNotification';
import { EmotionalClose } from './components/EmotionalClose';
const TransitionPhrase = () => <div className="max-w-3xl mx-auto px-6 py-4 md:py-8 text-center" data-id="element-0" data-mp="31ctaxf1x1e2u">
    <p className="text-lg md:text-2xl font-display italic text-brand-violetDark/85 leading-relaxed font-[800]" data-id="element-1" data-mp="2wj8fnurpiy7c">
      La próxima sesión puede ser diferente.
    </p>
  </div>;
export function App() {
  return <div className="min-h-screen text-brand-text font-sans selection:bg-brand-gold/25 selection:text-brand-violetDark bg-brand-surface" data-id="element-2" data-mp="23v2r0wxj8p28">
      <UrgencyBanner data-id="element-3" data-mp="3mlawd43m29se" />
      <Hero data-id="element-4" data-mp="3mkrbpfmkt7ao" />
      <PainPoints data-id="element-5" data-mp="3mkhofzsx1e8o" />
      <MethodOverview data-id="element-6" data-mp="3mjq1fdddwou0" />
      <MaterialPreview data-id="element-7" data-mp="3mj6k9yvk64h1" />
      <MoreTestimonials data-id="element-8" data-mp="3rbr9so7flver" />
      <Guarantee data-id="element-9" data-mp="3rdatkosaqola" />
      <FAQ data-id="element-10" data-mp="3rcsulke91w9o" />
      <CostComparison data-id="element-11" data-mp="3recdzjv7cnfo" />
      <TransitionPhrase data-id="element-12" data-mp="5yhgo69t1c8" />
      <EmotionalClose data-id="element-13" data-mp="680tswt8a8y" />
      <Footer data-id="element-14" data-mp="4n7u7q58zd7" />
      <FloatingNotification data-id="element-15" data-mp="56l3b4umzkw" />
    </div>;
}